// Lazy texture cache for the rocketry asset set (public/textures/rocketry,
// generated by scripts/generate-rocketry-textures.mjs). Each (name, repeat)
// pair is its own Texture object sharing the browser-cached file, so a
// material can tile the same image at its own scale. Files load on first
// use and fill in when they arrive; nothing blocks the mode from starting.

import * as THREE from 'three';

const cache = new Map();
const loader = new THREE.TextureLoader();
export const TEXTURE_BASE = '/textures/rocketry/';

// Textures that have derived companion maps, produced by
// scripts/generate-rocketry-pbr.mjs: <name>_n.webp is a tangent-space normal
// map and <name>_orm.webp packs ambient occlusion, roughness and metalness
// into R, G and B, the usual glTF convention. Macro tiles and the real Florida
// imagery are excluded: they are viewed from kilometres up, where surface
// relief means nothing and a normal map only adds shimmer.
export const PBR_TEXTURES = new Set([
  'site_deck', 'site_paint', 'site_zinc', 'site_tread', 'site_roof',
  'tank_white', 'tank_orange', 'foam_orange', 'carbon_weave', 'engine_bell', 'pod_hull', 'heat_shield',
  'solid_booster', 'solar_panel', 'structural_dark', 'steel_painted',
  'steel_rust', 'tank_steel', 'building_white', 'glass_curtain',
  'concrete_pad', 'asphalt', 'gravel', 'hangar_wall', 'hangar_floor',
  'florida_scrub', 'florida_grass', 'sand_coast', 'marsh', 'moon_regolith'
]);

// Attach the derived maps to a material spec. Roughness and metalness become
// map-driven, so their scalars go to 1 and let the packed channels through
// unscaled; the per-texture levels are baked into the ORM image itself.
export function withPbrMaps(spec, name, { repeat = [1, 1], anisotropy = 8, normalScale = 1 } = {}) {
  if (!PBR_TEXTURES.has(name)) return spec;
  spec.normalMap = getTexture(name + '_n', { repeat, anisotropy, colorSpace: THREE.NoColorSpace });
  spec.normalScale = new THREE.Vector2(normalScale, normalScale);
  const orm = getTexture(name + '_orm', { repeat, anisotropy, colorSpace: THREE.NoColorSpace });
  spec.roughnessMap = orm;
  spec.metalnessMap = orm;
  spec.roughness = 1;
  spec.metalness = 1;
  return spec;
}

export function getTexture(name, { repeat = [1, 1], anisotropy = 8, colorSpace = THREE.SRGBColorSpace } = {}) {
  const key = `${name}|${repeat[0]}|${repeat[1]}`;
  if (cache.has(key)) return cache.get(key);
  const t = loader.load(TEXTURE_BASE + name + '.webp');
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  t.colorSpace = colorSpace;
  t.anisotropy = anisotropy;
  t.repeat.set(repeat[0], repeat[1]);
  cache.set(key, t);
  return t;
}
